import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import UserPermissionForm from './UserPermissionForm';

const UserPermissionFormPopup = ({
  subject = null,
  updateHandler = () => {},
  permission = null,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Button
        size="sm"
        color="info"
        onClick={toggle}
        className="d-flex align-items-center gap-1"
      >
        {permission ? (
          <>
            <i className="bx bx-pen"></i> Edit
          </>
        ) : (
          <>
            <i className="bx bx-plus"></i> Create Permission
          </>
        )}
      </Button>

      <Modal
        size="lg"
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={toggle} className="border-bottom pb-3">
          {permission ? 'Edit Permission' : 'Create New Permission'}
        </ModalHeader>
        <ModalBody>
          <UserPermissionForm
            handleClose={toggle}
            isFromPopup={true}
            subject={subject}
            updateHandler={updateHandler}
            permission={permission}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default UserPermissionFormPopup;
